import _defineProperty from "/opt/gitlab-runner/builds/4TN/tech/audio/juke-web/juke-web/node_modules/@babel/runtime/helpers/esm/defineProperty.js";
export class ConsentLanguages {
  has(key) {
    return ConsentLanguages.langSet.has(key);
  }
  forEach(callback) {
    ConsentLanguages.langSet.forEach(callback);
  }
  get size() {
    return ConsentLanguages.langSet.size;
  }
}
_defineProperty(ConsentLanguages, "langSet", new Set(['BG', 'CA', 'CS', 'DA', 'DE', 'EL', 'EN', 'ES', 'ET', 'FI', 'FR', 'HR', 'HU', 'IT', 'JA', 'LT', 'LV', 'MT', 'NL', 'NO', 'PL', 'PT', 'RO', 'RU', 'SK', 'SL', 'SV', 'TR', 'ZH']));